import React from 'react';
import { useTranslation } from 'react-i18next';
import ErrorIcon from '../../icons/x-hex.svg';
import { ResultPageLayout } from '../../layouts/ResultPageLayout';
import { CustomerSupportLink } from '../buttons';
import { ReturnToBookingPortal } from './buttons';
import { ExpiredBookingProps } from './types';

export const ExpiredBooking = ({ linkTo, restaurantName }: ExpiredBookingProps) => {
	const { t } = useTranslation();

	return (
		<ResultPageLayout headerIcon={ErrorIcon} iconAltText={t('titles.modification_unavailable')}>
			<ResultPageLayout.Title>{t('titles.modification_unavailable')}</ResultPageLayout.Title>

			<ResultPageLayout.Body>
				<p>
					{t('messages.booking_expired_unavailable', { restaurantName })}
				</p>
				<p>
					{t('messages.contact_support_questions')} <CustomerSupportLink />
				</p>
			</ResultPageLayout.Body>

			<ResultPageLayout.Footer>
				<ReturnToBookingPortal to={linkTo} />
			</ResultPageLayout.Footer>
		</ResultPageLayout>
	);
};
